'use client';

import '@ui5/webcomponents-fiori/dist/SideNavigation.js';
import { withWebComponent } from '../../internal/withWebComponent.js';
/**
 * The `SideNavigation` is used as a standard menu in applications. It consists of three containers: header (top-aligned), main navigation section (top-aligned) and the secondary section (bottom-aligned).
 *
 * *   The header is meant for displaying user related information - profile data, avatar, etc.
 * *   The main navigation section is related to the user’s current work context
 * *   The secondary section is mostly used to link additional information that may be of interest (legal information, developer communities, external help, contact information and so on).
 *
 * __Note:__ This component is a web component developed by the UI5 Web Components’ team.
 *
 * [UI5 Web Components Storybook](https://sap.github.io/ui5-webcomponents/playground/?path=/docs/fiori-SideNavigation)
 */
const SideNavigation = withWebComponent('ui5-side-navigation', [], ['collapsed'], ['fixedItems', 'header'], ['selection-change']);
SideNavigation.displayName = 'SideNavigation';
export { SideNavigation };